import { ESortOrder } from "@domains/utils/sort";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { useDispatch } from "react-redux";
import "../../../../stylesheets/components/features/WatchList/actionwatchlist.scss";
export const WatchlistSorting = (props) => {
    const [id, setId] = React.useState();
    const setSortOrder = (parendIdx, childIdx, key, value) => {
        setId({ parentId: parendIdx, childId: childIdx });
        let tempData = props.sortingState;
        tempData = tempData.map((record, parentId) => {
            var _a;
            if (((_a = record.list) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                record.list.map((childRecord, childId) => {
                    if (parentId === parendIdx && childId === childIdx) {
                        childRecord.order =
                            value === ESortOrder.DESC ? ESortOrder.ASC : ESortOrder.DESC;
                    }
                    else {
                        childRecord.order = ESortOrder.UNCHANGED;
                    }
                    return childRecord;
                });
            }
            return record;
        });
        let sortRecord = tempData[parendIdx].list[childIdx];
        props.setId({ parentId: parendIdx, childId: childIdx });
        props.updateSortingState(tempData);
        props.handleSorting(tempData, sortRecord, props.particularWatchList);
    };
    const dispatch = useDispatch();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: ` ${props.parentClass ? props.parentClass : ""}` },
            !props.hideDrawerHeader && (React.createElement("div", { className: "drawer-header" },
                React.createElement("div", { className: "sortname" }, props.sortname),
                props.isClearAll ? ("") : (React.createElement(React.Fragment, null,
                    React.createElement("div", { onClick: () => {
                            props.clearall();
                        } },
                        React.createElement(EdButton, { value: "Clear", btnTyp: "blue-link" })))))),
            React.createElement("div", { className: "drawer-body" },
                React.createElement("div", { className: "max-height-scroll commonscroll-new" }, props === null || props === void 0 ? void 0 : props.sortingState.map((val, parentIdx) => {
                    var _a;
                    return (React.createElement(React.Fragment, null, val.list &&
                        ((_a = val.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        val.list.map((sortItem, childId) => {
                            return (React.createElement("div", { className: `sortlist-body ${props.sortingState &&
                                    props.sortingState[parentIdx].list[childId]
                                        .order === 0
                                    ? ""
                                    : "active-filter"}`, onClick: () => setSortOrder(parentIdx, childId, sortItem.title, sortItem.order) },
                                React.createElement("div", { className: "sortlist-names" }, sortItem.title),
                                React.createElement("div", { className: "sortlist-values" },
                                    sortItem.order === ESortOrder.ASC
                                        ? sortItem.orderText.asc
                                        : sortItem.orderText.desc,
                                    React.createElement("i", { className: props.sortingState &&
                                            props.sortingState[parentIdx].list[childId]
                                                .order == ESortOrder.ASC
                                            ? "edel-icon-point-arrow-up"
                                            : "edel-icon-point-arrow-down" }))));
                        })));
                }))))));
};
export default WatchlistSorting;
